import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDocumento } from '@interfaces/documento.interface';
import { InsuranceService } from 'src/app/core/services/insurance.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'aig-modal-documentation',
  imports: [ModalComponent, CommonModule],
  templateUrl: './modal-documentation.component.html',
  styleUrl: './modal-documentation.component.scss',
})
export class ModalDocumentationComponent implements OnInit {
  @Input() idSiniestro?: number;
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  documents: IDocumento[] = [];

  constructor(private insuranceService: InsuranceService) {}

  ngOnInit(): void {
    if (this.idSiniestro) {
      this.insuranceService
        .obtenerDocumentosSiniestro(this.idSiniestro)
        .subscribe({
          next: (response: any) => {
            this.documents = response.map(
              (f: any, index: number) => `Documento ${index + 1}`
            );
          },
          error: (err) => {
            console.error('Error al obtener documentos del siniestro:', err);
          },
        });
    }
  }

  downloadFile(doc: IDocumento): void {
    const byteArray = new Uint8Array(doc.contenido);
    const blob = new Blob([byteArray], { type: doc.mimeType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = doc.nombre;
    a.click();

    window.URL.revokeObjectURL(url);
  }

  clickHide(): void {
    this.hideModal.emit(true);
  }
}
